import React, { useState, useEffect } from "react";
import axios from 'axios';
import params from "../config/Params";
import { useParams } from 'react-router-dom'; 
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import { Drawer } from '@mui/material'

const WebRatings = () => {
  const { token, listingId } = useParams();
  const [ratings, setRatings] = useState([]);
  const [userComments, setUserComments] = useState([]);
  const [activeReplyId, setActiveReplyId] = useState(null);
  const [replyTexts, setReplyTexts] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [selectedRatingId, setSelectedRatingId] = useState(null);
  const [selectedRating, setSelectedRating] = useState(null);

  useEffect(() => {      
    const fetchRatingData = async () => {
      let formData = new FormData();
      formData.append('token', token);
      formData.append('listing_id', listingId);
  
      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.ratingList}`,
          data: formData,
        });
  
        if (response.data.status === 'ok') {
            setRatings(response.data.ratings);
            setUserComments(response.data.user_comments || []);
        } else {
          console.log('An error occurred while fetching data.');
        }
      } catch (err) {
        console.log(err.message);
      }
    };

    fetchRatingData();
  }, []);

  const CircularProgressBar = ({ percentage, value }) => {
    return (
      <div
        className="progress-circle"
        style={{ "--progress": `${percentage}%` }}
      >
        <span className="progress-text">{value}</span>
      </div>
    );
  };

  const toggleReplyBox = (ratingId, ratingData) => {
    setSelectedRatingId(ratingId);
    setSelectedRating(ratingData);
    setShowModal(true);
  };

  const handleReplyChange = (id, text) => {
    setReplyTexts(prev => ({ ...prev, [id]: text }));
  };

  const submitReply = async (ratingId) => {
    let formData = new FormData();
    formData.append('token', token);
    formData.append('rating_id', ratingId);
    formData.append('reply_text', replyTexts[ratingId] || '');

    try {
      const response = await axios({
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        url: `${params.baseURL}${params.endpoints.saveReply}`,
        data: formData,
      });
      if (response.data.status === 'ok') {
        toast.success('Reply saved successfully!');
        setUserComments(prevComments =>
          prevComments.map(comment =>
            comment.rating_id === ratingId
              ? { ...comment, reply_text: replyTexts[ratingId] }
              : comment
          )
        );
  
        setActiveReplyId(null);
        setReplyTexts(prev => ({ ...prev, [ratingId]: '' }));
      } else {
        toast.error('Failed to save reply.');
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <div>
        <Helmet>
            <title>Listing Ratings</title>
            <meta name='description' content='' />
        </Helmet>

        <style>
          {`
            #main {
              margin-top:0;
              padding: 20px 0px;
            }
            .progress-circle {
              flex: none;
              width: 110px;
              height: 110px;
            }
            .oval-rtng {
              font-size: 20px;
              background: #89cbff;
              border-radius: 4px;
              text-align: center;
              padding: 5px 5px;
              margin-bottom: 0;
            }
          `}
        </style>

        <div className="ap-offer-section">
            <div className="apoffbx">
                {ratings.length > 0 ? (
                  <div className='row'>
                    {ratings.find(r => r.case === "overall_rating") && (
                      <div className='col-md-12 lb'>
                        <div className="rating-box">
                          <div className="ovalrtng-box">
                            <CircularProgressBar percentage={(ratings.find(r => r.case === "overall_rating").count / 5) * 100} value={ratings.find(r => r.case === "overall_rating").count} />
                            <div style={{width:'4px', background:'#000', height:'110px'}}></div>
                            <div style={{display:'flex', alignItems: 'center', justifyContent:'center'}}>
                              <div>
                                <div className="rtnicntxt">
                                  <img src={ratings.find(r => r.case === "overall_rating").img} alt="wire stay" className="img-fluid" />
                                  <h4>{ratings.find(r => r.case === "overall_rating").title}</h4>
                                </div>
                                <p className="rating-score oval-rtng">{ratings.find(r => r.case === "overall_rating").count} / 5</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {ratings.filter(r => r.case !== "overall_rating").map((rating, index) => (
                      <div key={index} className='col-md-4 lb'>
                        <div className="rating-box">
                          <div className="rtnicntxt">
                            <img src={rating.img} alt="wire stay" className="img-fluid" />
                            <h4>{rating.title}</h4>
                          </div>
                          <div className="progress">
                            <div 
                              className="progress-bar bg-black" 
                              role="progressbar" 
                              style={{ width: `${(rating.count / 5) * 100}%`, position:'inherit' }}
                              aria-valuenow={rating.count} 
                              aria-valuemin="0" 
                              aria-valuemax="5">
                            </div>
                          </div>
                          <p className="rating-score">{rating.count} / 5</p>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="empty-chat-section ems">
                      <img src={'/assets/img/placeholder/no_rating_yet.svg'} className='empty-image img-fluid' alt='' />
                  </div>
                )}
            </div>

            <div className="user-comments-section mt-4">
              {userComments.some(comment => comment.user_comment) && (
                <>
                  <div className="row">
                  <div className="col-md-12"><h4 className="text-uppercase">User Comments</h4></div>
                  {userComments.map(comment => (
                    comment.user_comment ? (
                      <div key={comment.rating_id} className="col-md-4 mb-4">
                        <div className="comment-box p-3 border rounded">
                          <div className="cmbx-iurt">
                            <img src="/assets/img/host_default_image.png" alt="default"className='rpi-img' />
                            <span className="cmbx-line"></span>
                            <div className="cmbx-unrt">
                              <span>{comment.user_name}</span>
                              <span>{comment.rating_received_on}</span>
                            </div>
                          </div>
                          <div className='mrrsbox' style={{borderRadius:'2px', padding:'8px', marginBottom:'1rem', justifyContent:'center'}}>
                            <div className='mrrspn'>
                              <span>
                                {Array.from({ length: 5 }).map((_, index) => {
                                    const rating = comment.overall_rating;
                                    const fullStars = Math.floor(rating);
                                    const hasHalfStar = rating - fullStars >= 0.25 && rating - fullStars < 0.75;

                                    if (index < fullStars) {
                                        return <i key={index} className="fas fa-star"></i>;
                                    } else if (index === fullStars && hasHalfStar) {
                                        return <i key={index} className="fas fa-star-half-alt"></i>;
                                    } else {
                                        return <i key={index} className="far fa-star"></i>;
                                    }
                                })}
                              </span>
                            </div>
                          </div>
                          <div className="cmbx-ucmt">
                            <p>{comment.user_comment}</p>
                          </div>

                          {/*{comment.reply_text && (
                            <div className="mt-2 mb-4 ps-3 border-start border-2 border-primary">
                              <strong className="d-block mb-1">You replied:</strong>
                              <p className="mb-0">{comment.reply_text}</p>
                            </div>
                          )}*/}

                          <button
                            className="btn-reply"
                            onClick={() => toggleReplyBox(comment.rating_id, comment)}
                          >
                            {activeReplyId === comment.rating_id ? "Cancel" : "Reply"}
                          </button>

                          {/*{activeReplyId === comment.rating_id && (
                            <div className="mt-3">
                              <textarea
                                className="form-control mb-2"
                                placeholder="Write your reply..."
                                value={replyTexts[comment.rating_id] || ""}
                                onChange={(e) => handleReplyChange(comment.rating_id, e.target.value)}
                              />
                              <button className="btn btn-sm btn-success" onClick={() => submitReply(comment.rating_id)}>Submit Reply</button>
                            </div>
                          )}*/}
                        </div>
                      </div>
                    ) : null
                  ))}
                  </div>
                </>
              )}
            </div>

        </div>

        <Drawer
          anchor="bottom"
          open={showModal}
          onClose={() => setShowModal(false)}
        >
          <div className="modal-content" style={{ padding: '20px 12px' }}>
            {selectedRating?.reply_text ? (
              <>
                <div className="mccmbx-div">
                  <div className="cmbx-iurt">
                    <img src="/assets/img/host_default_image.png" alt="default" className="rpi-img" />
                    <span className="cmbx-line"></span>
                    <div className="cmbx-unrt">
                      <span>{selectedRating.listing_title}</span>
                      <span>{selectedRating.reply_time}</span>
                    </div>
                  </div>
                </div>

                <div className="mt-2 mb-4">
                  <p className="mb-0">{selectedRating.reply_text}</p>
                </div>
                <button className="btn-reply" onClick={() => setShowModal(false)}>Reply Done</button>
              </>
            ) : (
              <>
                <p className="text-uppercase">Reply to Comment</p>
                <textarea
                  className="form-control mb-3"
                  rows="4"
                  placeholder="Write your reply..."
                  value={replyTexts[selectedRatingId] || ""}
                  onChange={(e) => handleReplyChange(selectedRatingId, e.target.value)}
                />
                <div className="tdvbtn-box" style={{ padding: '0' }}>
                  <button className="acc-btn-txt btn-reject" onClick={() => setShowModal(false)}>Cancel</button>
                  <button className="acc-btn-txt btn-accept" onClick={() => {
                    submitReply(selectedRatingId);
                    setShowModal(false);
                  }}>Submit</button>
                </div>
              </>
            )}
          </div>
        </Drawer>

    </div>
  );
};

export default WebRatings;
